import { Actions } from '../constants';

export default function hideMobileNav() {
  return {
    type: Actions.HIDE_MOBILE_NAV,
  };
}
